export const Logo = ({fill}) => {
    return(
      <>
        <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="350" height="180" viewBox="0 0 4000.000000 2250.000000"
 preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,2250.000000) scale(0.100000,-0.100000)"
fill="#fff" stroke="none">
<path d="M19585 19336 c-239 -55 -418 -198 -526 -420 -56 -115 -72 -201 -67
-354 4 -104 10 -141 32 -207 39 -114 98 -209 185 -296 129 -129 283 -202 463
-218 368 -34 688 182 800 539 19 64 23 96 23 215 0 118 -4 152 -23 215 -76
244 -265 434 -507 510 -90 28 -290 37 -380 16z"/>
<path d="M18055 18067 c-34 -13 -919 -518 -1105 -630 -513 -309 -632 -485
-669 -992 -16 -215 -26 -2644 -12 -2807 17 -186 50 -328 105 -443 55 -117 92
-172 175 -259 137 -142 291 -247 796 -541 187 -109 432 -252 545 -319 113 -67
282 -167 377 -222 l172 -99 3 -550 c4 -616 0 -584 79 -670 58 -63 125 -89 215
-83 55 4 83 11 118 32 55 32 111 104 125 163 8 29 11 843 11 2632 0 2807 -3
2662 53 2801 14 33 40 86 58 118 44 73 178 207 251 251 311 182 679 135 929
-119 112 -113 183 -257 208 -418 8 -50 11 -674 11 -2064 0 -1983 1 -1993 21
-2038 53 -119 183 -187 303 -160 43 9 204 98 721 393 116 67 336 192 490 280
583 330 717 418 870 572 118 119 182 219 231 362 79 234 84 332 87 1908 2
1220 1 1318 -16 1424 -50 318 -153 478 -437 681 -120 86 -270 178 -719 440
-196 114 -410 240 -476 279 -135 81 -177 95 -256 88 -63 -5 -102 -23 -155 -70
-111 -97 -112 -292 -3 -393 36 -33 275 -177 734 -444 373 -216 493 -297 591
-394 128 -129 174 -248 193 -500 12 -161 5 -2205 -9 -2487 -19 -393 -65 -482
-345 -665 -109 -71 -1262 -734 -1277 -734 -4 0 -8 795 -8 1768 0 1959 3 1855
-66 2062 -108 322 -345 595 -649 745 -202 100 -357 136 -580 136 -220 0 -395
-40 -581 -134 -358 -180 -611 -513 -696 -917 -20 -93 -20 -141 -25 -1877 -3
-981 -7 -1783 -9 -1783 -7 0 -149 81 -279 160 -66 40 -281 167 -478 281 -549
321 -648 386 -739 487 -83 93 -111 177 -129 386 -14 159 -4 2351 12 2571 30
420 125 538 694 861 513 291 770 441 805 471 21 19 51 58 66 89 24 48 26 63
22 128 -6 85 -35 145 -95 195 -67 56 -183 77 -258 48z"/>
<path d="M16559 9429 c-440 -64 -804 -360 -963 -781 -57 -153 -70 -239 -70
-448 1 -177 3 -204 26 -291 78 -289 228 -512 463 -685 201 -148 411 -220 680
-231 423 -18 793 157 1042 494 169 228 240 467 230 778 -9 290 -79 486 -253
711 -231 299 -591 467 -990 463 -60 -1 -134 -5 -165 -10z m416 -279 c370 -99
646 -398 705 -764 20 -122 8 -341 -24 -451 -99 -332 -349 -573 -682 -657 -125
-31 -352 -31 -469 1 -89 24 -221 84 -291 132 -177 121 -316 313 -381 526 -25
82 -27 101 -27 268 0 214 15 281 94 442 133 269 386 463 678 518 106 20 292
13 397 -15z"/>
<path d="M11230 8215 l0 -1165 130 0 130 0 0 1165 0 1165 -130 0 -130 0 0
-1165z"/>
<path d="M12620 8215 l0 -1165 140 0 140 0 2 843 3 843 735 -843 735 -842 43
-1 42 0 0 1165 0 1165 -135 0 -135 0 -2 -853 -3 -853 -740 852 -740 853 -42 0
-43 1 0 -1165z"/>
<path d="M18884 9283 c24 -54 249 -579 501 -1166 l458 -1068 40 3 40 3 499
1145 c274 630 501 1153 504 1163 5 16 -4 17 -141 15 l-147 -3 -376 -863 c-206
-474 -379 -859 -383 -855 -4 5 -172 394 -374 866 l-367 857 -149 0 -148 0 43
-97z"/>
<path d="M22253 8233 c-298 -631 -545 -1156 -548 -1165 -7 -17 4 -18 142 -18
l149 0 176 373 176 372 484 3 483 2 179 -375 179 -375 143 0 c79 0 144 2 144
5 0 3 -243 526 -540 1163 l-539 1157 -43 3 -43 3 -542 -1148z m766 207 c94
-201 171 -368 171 -372 0 -5 -160 -8 -355 -8 -195 0 -355 3 -355 6 0 19 355
753 360 747 4 -5 84 -172 179 -373z"/>
<path d="M24680 9250 l0 -130 255 0 255 0 0 -1035 0 -1035 140 0 140 0 0 1035
0 1035 255 0 255 0 0 130 0 130 -650 0 -650 0 0 -130z"/>
<path d="M26910 8215 l0 -1165 670 0 670 0 0 130 0 130 -535 0 -535 0 0 435 0
435 535 0 535 0 0 130 0 130 -535 0 -535 0 0 340 0 340 540 0 540 0 0 130 0
130 -675 0 -675 0 0 -1165z"/>
<path d="M16080 5927 c-25 -13 -52 -35 -60 -50 -14 -25 -13 -28 7 -49 l22 -21
39 26 c21 15 47 27 57 27 10 0 49 -16 86 -35 38 -19 77 -35 89 -35 35 0 77 27
100 65 l22 35 -24 20 c-30 25 -30 25 -58 -5 -31 -33 -59 -32 -119 6 -69 42
-106 46 -161 16z"/>
<path d="M16111 5715 c-121 -34 -190 -109 -227 -247 -17 -64 -18 -246 -3 -320
24 -114 87 -201 177 -245 51 -25 68 -28 157 -28 86 0 107 4 155 26 99 46 158
128 186 258 27 127 11 298 -36 396 -29 59 -85 114 -146 142 -68 31 -187 39
-263 18z m204 -104 c50 -23 78 -53 107 -116 21 -45 23 -65 23 -195 0 -130 -2
-150 -23 -195 -43 -94 -105 -134 -204 -135 -72 0 -104 12 -151 58 -49 48 -77
125 -84 234 -12 178 41 309 142 354 44 19 143 17 190 -5z"/>
<path d="M12101 5705 c-63 -18 -114 -54 -142 -99 -29 -47 -27 -162 4 -207 37
-55 100 -95 204 -129 176 -59 235 -99 235 -163 0 -51 -27 -94 -75 -119 -36
-19 -56 -22 -137 -21 -52 0 -128 8 -169 17 -41 9 -77 14 -79 11 -3 -2 -8 -22
-12 -45 -7 -40 -7 -40 29 -50 172 -46 376 -36 465 22 85 56 120 179 77 273
-33 73 -104 117 -261 165 -136 40 -190 82 -190 144 0 114 134 151 358 100 35
-8 65 -14 67 -14 7 0 27 82 21 87 -14 15 -133 34 -231 38 -81 4 -125 1 -164
-10z"/>
<path d="M12937 5709 c-97 -23 -180 -98 -218 -198 -28 -70 -38 -273 -19 -360
38 -175 141 -267 309 -278 182 -13 306 71 358 242 24 82 25 286 1 365 -36 115
-110 192 -218 224 -58 17 -152 19 -213 5z m190 -100 c42 -15 93 -68 114 -118
41 -93 41 -294 -1 -387 -41 -94 -102 -134 -203 -134 -163 0 -250 136 -234 369
13 193 86 280 234 281 34 0 74 -5 90 -11z"/>
<path d="M15307 5700 c-66 -25 -108 -60 -145 -117 -81 -126 -92 -379 -23 -529
48 -102 112 -153 227 -177 l55 -11 -3 -39 c-2 -35 1 -40 29 -52 78 -33 39
-109 -46 -92 -25 5 -30 2 -33 -18 -6 -28 11 -35 90 -35 46 0 58 4 83 29 39 40
39 82 0 122 -16 16 -39 29 -50 29 -16 0 -21 6 -21 29 0 27 3 29 53 35 71 10
173 36 192 50 12 9 13 18 4 49 -9 33 -14 38 -32 33 -111 -32 -152 -40 -217
-40 -106 0 -180 43 -223 129 -47 96 -50 289 -5 386 65 141 200 182 400 119 34
-11 64 -20 65 -20 1 0 7 19 13 41 14 50 14 50 -91 79 -100 27 -253 27 -322 0z"/>
<path d="M17641 5705 c-63 -18 -114 -54 -142 -99 -29 -47 -27 -162 4 -207 37
-55 100 -95 204 -129 176 -59 235 -99 235 -163 0 -51 -27 -94 -75 -119 -36
-19 -56 -22 -137 -21 -52 0 -128 8 -169 17 -41 9 -77 14 -79 11 -3 -2 -8 -22
-12 -45 -7 -40 -7 -40 29 -50 172 -46 376 -36 465 22 85 56 120 179 77 273
-33 73 -104 117 -261 165 -136 40 -190 82 -190 144 0 114 134 151 358 100 35
-8 65 -14 67 -14 7 0 27 82 21 87 -14 15 -133 34 -231 38 -81 4 -125 1 -164
-10z"/>
<path d="M22467 5709 c-97 -23 -180 -98 -218 -198 -28 -70 -38 -273 -19 -360
38 -175 141 -267 309 -278 182 -13 306 71 358 242 24 82 25 286 1 365 -36 115
-110 192 -218 224 -58 17 -152 19 -213 5z m190 -100 c42 -15 93 -68 114 -118
41 -93 41 -294 -1 -387 -41 -94 -102 -134 -203 -134 -163 0 -250 136 -234 369
13 193 86 280 234 281 34 0 74 -5 90 -11z"/>
<path d="M23350 5706 c-96 -25 -173 -96 -212 -195 -20 -50 -23 -74 -23 -216 0
-143 3 -166 23 -216 50 -125 151 -197 289 -206 83 -6 210 13 277 41 35 15 37
18 31 48 -4 18 -10 37 -15 41 -4 4 -40 -1 -81 -13 -96 -26 -218 -27 -275 -1
-95 43 -139 140 -139 306 0 166 44 263 139 306 57 26 179 25 275 -1 41 -12 77
-17 81 -13 5 4 11 23 15 41 6 30 4 33 -31 48 -95 40 -266 54 -354 30z"/>
<path d="M24791 5705 c-63 -18 -114 -54 -142 -99 -29 -47 -27 -162 4 -207 37
-55 100 -95 204 -129 176 -59 235 -99 235 -163 0 -51 -27 -94 -75 -119 -36
-19 -56 -22 -137 -21 -52 0 -128 8 -169 17 -41 9 -77 14 -79 11 -3 -2 -8 -22
-12 -45 -7 -40 -7 -40 29 -50 172 -46 376 -36 465 22 85 56 120 179 77 273
-33 73 -104 117 -261 165 -136 40 -190 82 -190 144 0 114 134 151 358 100 35
-8 65 -14 67 -14 7 0 27 82 21 87 -14 15 -133 34 -231 38 -81 4 -125 1 -164
-10z"/>
<path d="M25531 5705 c-63 -18 -114 -54 -142 -99 -29 -47 -27 -162 4 -207 37
-55 100 -95 204 -129 176 -59 235 -99 235 -163 0 -51 -27 -94 -75 -119 -36
-19 -56 -22 -137 -21 -52 0 -128 8 -169 17 -41 9 -77 14 -79 11 -3 -2 -8 -22
-12 -45 -7 -40 -7 -40 29 -50 172 -46 376 -36 465 22 85 56 120 179 77 273
-33 73 -104 117 -261 165 -136 40 -190 82 -190 144 0 114 134 151 358 100 35
-8 65 -14 67 -14 7 0 27 82 21 87 -14 15 -133 34 -231 38 -81 4 -125 1 -164
-10z"/>
<path d="M26367 5709 c-97 -23 -180 -98 -218 -198 -28 -70 -38 -273 -19 -360
38 -175 141 -267 309 -278 182 -13 306 71 358 242 24 82 25 286 1 365 -36 115
-110 192 -218 224 -58 17 -152 19 -213 5z m190 -100 c42 -15 93 -68 114 -118
41 -93 41 -294 -1 -387 -41 -94 -102 -134 -203 -134 -163 0 -250 136 -234 369
13 193 86 280 234 281 34 0 74 -5 90 -11z"/>
<path d="M27161 5705 c-63 -18 -114 -54 -142 -99 -29 -47 -27 -162 4 -207 37
-55 100 -95 204 -129 176 -59 235 -99 235 -163 0 -51 -27 -94 -75 -119 -36
-19 -56 -22 -137 -21 -52 0 -128 8 -169 17 -41 9 -77 14 -79 11 -3 -2 -8 -22
-12 -45 -7 -40 -7 -40 29 -50 172 -46 376 -36 465 22 85 56 120 179 77 273
-33 73 -104 117 -261 165 -136 40 -190 82 -190 144 0 114 134 151 358 100 35
-8 65 -14 67 -14 7 0 27 82 21 87 -14 15 -133 34 -231 38 -81 4 -125 1 -164
-10z"/>
<path d="M13600 5295 l0 -415 255 0 255 0 0 50 0 50 -200 0 -200 0 0 365 0
365 -55 0 -55 0 0 -415z"/>
<path d="M14272 5383 c3 -317 4 -329 25 -369 30 -56 93 -109 151 -125 26 -8
85 -14 132 -14 47 0 106 6 132 14 58 16 121 69 151 125 21 40 22 52 25 369 l3
327 -55 0 -55 0 -3 -307 c-3 -290 -4 -310 -24 -348 -31 -59 -82 -85 -169 -85
-92 0 -150 28 -179 85 -20 37 -21 60 -24 348 l-3 307 -55 0 -55 0 3 -327z"/>
<path d="M16780 5295 l0 -415 265 0 265 0 0 50 0 50 -210 0 -210 0 0 145 0
145 180 0 180 0 0 45 0 45 -180 0 -180 0 0 125 0 125 205 0 205 0 0 50 0 50
-260 0 -260 0 0 -415z"/>
<path d="M18580 5295 l0 -415 265 0 265 0 0 50 0 50 -210 0 -210 0 0 145 0
145 180 0 180 0 0 45 0 45 -180 0 -180 0 0 125 0 125 205 0 205 0 0 50 0 50
-260 0 -260 0 0 -415z"/>
<path d="M19310 5295 l0 -415 50 0 50 0 1 328 0 327 130 -257 129 -258 43 0
42 0 130 258 130 257 3 -327 2 -328 55 0 55 0 0 415 0 415 -75 0 -75 0 -14
-32 c-8 -18 -66 -140 -130 -271 l-117 -238 -134 270 -134 271 -71 0 -70 0 0
-415z"/>
<path d="M20670 5295 l0 -415 55 0 55 0 0 170 0 170 158 0 c176 0 210 9 269
70 96 99 78 298 -35 372 -62 41 -104 48 -309 48 l-193 0 0 -415z m417 295 c84
-51 88 -204 6 -257 -22 -15 -54 -19 -170 -21 l-143 -4 0 151 0 151 138 0 c118
0 141 -3 169 -20z"/>
<path d="M21450 5296 l0 -416 55 0 55 0 0 165 0 165 93 0 92 0 100 -165 100
-164 63 -1 c34 0 62 3 62 6 0 3 -43 77 -95 164 -52 87 -95 160 -95 163 0 3 20
15 45 27 77 37 124 118 125 216 0 100 -41 175 -124 221 -51 28 -51 28 -263 31
l-213 3 0 -415z m417 294 c42 -25 65 -72 65 -131 0 -59 -25 -106 -71 -133 -28
-16 -58 -20 -167 -24 l-134 -5 0 157 0 156 138 0 c118 0 141 -3 169 -20z"/>
<path d="M23930 5295 l0 -415 265 0 265 0 0 50 0 50 -210 0 -210 0 0 145 0
145 180 0 180 0 0 45 0 45 -180 0 -180 0 0 125 0 125 205 0 205 0 0 50 0 50
-260 0 -260 0 0 -415z"/>
<path d="M11972 3838 c-78 -227 -142 -416 -142 -420 0 -5 24 -8 54 -8 l54 0
38 110 39 110 165 0 166 0 35 -107 35 -108 62 -3 62 -3 -143 420 -142 421 -70
0 -71 0 -142 -412z m348 -115 c0 -10 -32 -13 -140 -13 -93 0 -140 4 -140 11 0
8 108 324 136 399 5 14 144 -369 144 -397z"/>
<path d="M17232 3838 c-78 -227 -142 -416 -142 -420 0 -5 24 -8 54 -8 l54 0
38 110 39 110 165 0 166 0 35 -107 35 -108 62 -3 62 -3 -143 420 -142 421 -70
0 -71 0 -142 -412z m348 -115 c0 -10 -32 -13 -140 -13 -93 0 -140 4 -140 11 0
8 108 324 136 399 5 14 144 -369 144 -397z"/>
<path d="M18451 4235 c-63 -18 -114 -54 -142 -99 -29 -47 -27 -162 4 -207 37
-55 100 -95 204 -129 176 -59 235 -99 235 -163 0 -51 -27 -94 -75 -119 -36
-19 -56 -22 -137 -21 -52 0 -128 8 -169 17 -41 9 -77 14 -79 11 -3 -2 -8 -22
-12 -45 -7 -40 -7 -40 29 -50 172 -46 376 -36 465 22 85 56 120 179 77 273
-33 73 -104 117 -261 165 -136 40 -190 82 -190 144 0 114 134 151 358 100 35
-8 65 -14 67 -14 7 0 27 82 21 87 -14 15 -133 34 -231 38 -81 4 -125 1 -164
-10z"/>
<path d="M23491 4235 c-63 -18 -114 -54 -142 -99 -29 -47 -27 -162 4 -207 37
-55 100 -95 204 -129 176 -59 235 -99 235 -163 0 -51 -27 -94 -75 -119 -36
-19 -56 -22 -137 -21 -52 0 -128 8 -169 17 -41 9 -77 14 -79 11 -3 -2 -8 -22
-12 -45 -7 -40 -7 -40 29 -50 172 -46 376 -36 465 22 85 56 120 179 77 273
-33 73 -104 117 -261 165 -136 40 -190 82 -190 144 0 114 134 151 358 100 35
-8 65 -14 67 -14 7 0 27 82 21 87 -14 15 -133 34 -231 38 -81 4 -125 1 -164
-10z"/>
<path d="M26022 3838 c-78 -227 -142 -416 -142 -420 0 -5 24 -8 54 -8 l54 0
38 110 39 110 165 0 166 0 35 -107 35 -108 62 -3 62 -3 -143 420 -142 421 -70
0 -71 0 -142 -412z m348 -115 c0 -10 -32 -13 -140 -13 -93 0 -140 4 -140 11 0
8 108 324 136 399 5 14 144 -369 144 -397z"/>
<path d="M27241 4235 c-63 -18 -114 -54 -142 -99 -29 -47 -27 -162 4 -207 37
-55 100 -95 204 -129 176 -59 235 -99 235 -163 0 -51 -27 -94 -75 -119 -36
-19 -56 -22 -137 -21 -52 0 -128 8 -169 17 -41 9 -77 14 -79 11 -3 -2 -8 -22
-12 -45 -7 -40 -7 -40 29 -50 172 -46 376 -36 465 22 85 56 120 179 77 273
-33 73 -104 117 -261 165 -136 40 -190 82 -190 144 0 114 134 151 358 100 35
-8 65 -14 67 -14 7 0 27 82 21 87 -14 15 -133 34 -231 38 -81 4 -125 1 -164
-10z"/>
<path d="M12710 3825 l0 -415 50 0 50 0 1 328 0 327 130 -257 129 -258 43 0
42 0 130 258 130 257 3 -327 2 -328 55 0 55 0 0 415 0 415 -75 0 -75 0 -14
-32 c-8 -18 -66 -140 -130 -271 l-117 -238 -134 270 -134 271 -71 0 -70 0 0
-415z"/>
<path d="M13770 3824 l0 -415 223 3 c214 3 224 4 272 28 92 46 135 149 105
254 -15 53 -65 109 -114 127 l-34 12 46 31 c59 40 85 91 85 166 -1 68 -29 128
-73 160 -59 42 -111 50 -317 50 l-193 0 0 -416z m428 282 c35 -32 37 -38 37
-94 0 -107 -44 -132 -230 -132 l-125 0 0 130 0 130 140 0 140 0 38 -34z m-11
-339 c51 -27 73 -63 73 -119 0 -27 -7 -62 -15 -78 -27 -52 -58 -60 -220 -60
l-145 0 0 141 0 142 138 -5 c101 -3 145 -9 169 -21z"/>
<path d="M14580 3825 l0 -415 55 0 55 0 0 415 0 415 -55 0 -55 0 0 -415z"/>
<path d="M14930 3825 l0 -415 265 0 265 0 0 50 0 50 -210 0 -210 0 0 145 0
145 180 0 180 0 0 45 0 45 -180 0 -180 0 0 125 0 125 205 0 205 0 0 50 0 50
-260 0 -260 0 0 -415z"/>
<path d="M15660 3826 l0 -416 50 0 50 0 2 311 3 310 210 -310 210 -310 58 -1
57 0 0 415 0 415 -50 0 -50 0 0 -317 c0 -253 -3 -315 -12 -305 -7 7 -105 149
-218 315 l-206 302 -52 3 -52 3 0 -415z"/>
<path d="M16472 4193 l3 -48 118 -3 117 -3 0 -364 0 -365 55 0 55 0 0 365 0
365 120 0 120 0 0 50 0 50 -296 0 -295 0 3 -47z"/>
<path d="M17970 3825 l0 -415 55 0 55 0 0 415 0 415 -55 0 -55 0 0 -415z"/>
<path d="M19380 3825 l0 -415 265 0 265 0 0 50 0 50 -210 0 -210 0 0 145 0
145 180 0 180 0 0 45 0 45 -180 0 -180 0 0 125 0 125 205 0 205 0 0 50 0 50
-260 0 -260 0 0 -415z"/>
<path d="M20420 3825 l0 -415 55 0 55 0 0 415 0 415 -55 0 -55 0 0 -415z"/>
<path d="M20770 3826 l0 -416 50 0 50 0 2 311 3 310 210 -310 210 -310 58 -1
57 0 0 415 0 415 -50 0 -50 0 0 -317 c0 -253 -3 -315 -12 -305 -7 7 -105 149
-218 315 l-206 302 -52 3 -52 3 0 -415z"/>
<path d="M21650 3825 l0 -417 198 4 c219 4 249 11 326 78 71 63 115 192 116
336 0 194 -67 329 -193 385 -48 22 -69 24 -249 27 l-198 4 0 -417z m387 300
c21 -9 46 -23 56 -33 36 -32 67 -109 75 -186 18 -172 -20 -311 -101 -364 -38
-25 -48 -27 -174 -30 l-133 -4 0 316 0 316 120 0 c86 0 131 -4 157 -15z"/>
<path d="M22492 3913 c3 -317 4 -329 25 -369 30 -56 93 -109 151 -125 26 -8
85 -14 132 -14 47 0 106 6 132 14 58 16 121 69 151 125 21 40 22 52 25 369 l3
327 -55 0 -55 0 -3 -307 c-3 -290 -4 -310 -24 -348 -31 -59 -82 -85 -169 -85
-92 0 -150 28 -179 85 -20 37 -21 60 -24 348 l-3 307 -55 0 -55 0 3 -327z"/>
<path d="M24032 4193 l3 -48 118 -3 117 -3 0 -364 0 -365 55 0 55 0 0 365 0
365 120 0 120 0 0 50 0 50 -296 0 -295 0 3 -47z"/>
<path d="M24800 3826 l0 -416 55 0 55 0 0 165 0 165 93 0 92 0 100 -165 100
-164 63 -1 c34 0 62 3 62 6 0 3 -43 77 -95 164 -52 87 -95 160 -95 163 0 3 20
15 45 27 77 37 124 118 125 216 0 100 -41 175 -124 221 -51 28 -51 28 -263 31
l-213 3 0 -415z m417 294 c42 -25 65 -72 65 -131 0 -59 -25 -106 -71 -133 -28
-16 -58 -20 -167 -24 l-134 -5 0 157 0 156 138 0 c118 0 141 -3 169 -20z"/>
<path d="M25600 3825 l0 -415 55 0 55 0 0 415 0 415 -55 0 -55 0 0 -415z"/>
<path d="M26770 3825 l0 -415 55 0 55 0 0 415 0 415 -55 0 -55 0 0 -415z"/>
</g>
</svg>

      </>
    )
}